import { createSlice } from '@reduxjs/toolkit';

const TOKEN_STORAGE_KEY = 'tavern_token';

const readStoredToken = () => {
  try {
    return window.localStorage.getItem(TOKEN_STORAGE_KEY) || '';
  } catch {
    return '';
  }
};

const persistToken = (token) => {
  if (token) {
    window.localStorage.setItem(TOKEN_STORAGE_KEY, token);
  } else {
    window.localStorage.removeItem(TOKEN_STORAGE_KEY);
  }
};

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token: readStoredToken(),
  },
  reducers: {
    loginSucceeded: (state, action) => {
      state.token = action.payload;
      persistToken(action.payload);
    },
    loggedOut: (state) => {
      state.token = '';
      persistToken('');
    },
  },
});

export const { loggedOut, loginSucceeded } = authSlice.actions;

export const selectAuthToken = (state) => state.auth.token;
export const selectIsAuthenticated = (state) => Boolean(state.auth.token);

export default authSlice.reducer;
